import { ref, getDownloadURL, uploadString } from 'firebase/storage'
import { getTenantContextInstance as tenantCtx } from '@/plugins/tenant'

/**
 * Loads form schema JSON from Cloud Storage
 *
 * @param {string} formId - The form ID
 *
 * @returns {Promise<Object|null>} The schema object or null if not found
 */
export async function loadFormSchemaFromStorage(formId) {
  // Validate that formId is not empty, null, or undefined
  if (!formId || formId === '' || formId === 'undefined' || formId === 'null') {
    return null
  }

  try {
    const { formsStorage } = tenantCtx()
    const fileRef = ref(formsStorage, `${formId}.json`)
    
    const url = await getDownloadURL(fileRef)
    const response = await fetch(url)

    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`)
    }

    return await response.json()
  } catch (error) {
    // Expected for new forms without schema in storage
    if (
      error.code === 'storage/object-not-found' ||
      error.code === 'storage/not-found'
    ) {
      return null
    }

    // Log unexpected errors (permission denied, network issues, etc.)
    console.error('Error loading form schema from storage:', error)
    return null
  }
}

/**
 * Uploads form schema JSON to Cloud Storage
 *
 * @param {string} formId - The form ID
 * @param {Object} schema - The schema object to upload
 *
 * @returns {Promise<Object>} Upload result with metadata
 */
export async function uploadFormSchemaToStorage(formId, schema) {
  const { formsStorage } = tenantCtx()
  const fileRef = ref(formsStorage, `${formId}.json`)
  const jsonString = JSON.stringify(schema)

  try {
    const result = await uploadString(fileRef, jsonString, 'raw', {
      contentType: 'application/json',
    })

    return result
  } catch (error) {
    console.error('Error uploading form schema to storage:', error)
    throw error
  }
}



